/* KBM Scarcity Indicator - Shows "Only X yards left" near ATC for low-stock fabrics */
(function(){
  if (!document.body.classList.contains('template-product')) return;
  if (/\/products\/kbmfabrics-swatches/i.test(location.pathname)) return; /* skip swatches */

  function build(qty){
    var existing = document.getElementById('kbmScarcity');
    if (existing) existing.remove();
    if (qty == null || qty <= 0 || qty >= 30) return;

    var level = qty <= 5 ? 'critical' : (qty <= 15 ? 'high' : 'medium');
    var icon, message;
    if (level === 'critical') {
      icon = '🔥';
      message = '<strong>Only ' + qty + ' yard' + (qty === 1 ? '' : 's') + ' left!</strong> Once this batch is gone, it is gone.';
    } else if (level === 'high') {
      icon = '⚡';
      message = '<strong>Only ' + qty + ' yards left</strong> in this batch';
    } else {
      icon = '📉';
      message = '<strong>Low stock</strong> &mdash; ' + qty + ' yards remaining';
    }

    var badge = document.createElement('div');
    badge.id = 'kbmScarcity';
    badge.className = 'kbm-scarcity kbm-scarcity--' + level;
    badge.innerHTML = '<span class="kbm-scarcity__icon">' + icon + '</span><span class="kbm-scarcity__text">' + message + '</span>';

    /* Inject ABOVE the Add to Cart button, after the quantity selector */
    var atc = document.querySelector('.product-add-btn');
    if (atc && atc.parentNode) {
      atc.parentNode.insertBefore(badge, atc);
    }
  }

  function fetchInventory(){
    var handle = (location.pathname.match(/\/products\/([^\/\?#]+)/) || [])[1];
    if (!handle) return;
    fetch('/products/' + handle + '.js')
      .then(function(r){ return r.json(); })
      .then(function(product){
        if (!product || !product.variants) return;
        var variantSelect = document.querySelector('select[name="id"], input[name="id"]');
        var currentId = variantSelect ? parseInt(variantSelect.value, 10) : product.variants[0].id;
        var v = product.variants.find(function(x){ return x.id === currentId; }) || product.variants[0];
        if (!v) return;
        /* Only show if inventory is managed by Shopify and quantity is tracked */
        if (v.inventory_management !== 'shopify') return;
        build(v.inventory_quantity);
        return product;
      })
      .then(function(product){
        if (!product) return;
        /* Update on variant change */
        var variantSelect = document.querySelector('select[name="id"]');
        if (variantSelect) {
          variantSelect.addEventListener('change', function(){
            var newId = parseInt(variantSelect.value, 10);
            var v = product.variants.find(function(x){ return x.id === newId; });
            if (v && v.inventory_management === 'shopify') build(v.inventory_quantity);
            else { var ex = document.getElementById('kbmScarcity'); if (ex) ex.remove(); }
          });
        }
        /* Also handle color swatch clicks (writes to the same select) */
        document.querySelectorAll('.kbm-swatch').forEach(function(btn){
          btn.addEventListener('click', function(){
            setTimeout(function(){
              var sel = document.querySelector('select[name="id"]');
              if (!sel) return;
              var newId = parseInt(sel.value, 10);
              var v = product.variants.find(function(x){ return x.id === newId; });
              if (v && v.inventory_management === 'shopify') build(v.inventory_quantity);
              else { var ex = document.getElementById('kbmScarcity'); if (ex) ex.remove(); }
            }, 80);
          });
        });
      })
      .catch(function(){});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fetchInventory);
  } else {
    fetchInventory();
  }
})();
